import { api } from '@/services'
import { fetchAmount } from '@/services/appointment/appointmentService'

const state = {
  appointmentFields: {
    type: null,
    real_estate_branch_id: null,
    external_code: null,

    date: null,

    realties: [],
    realties_complete: [],

    observations: null,
    displacement: 0,
    needs_authorization: false,
    fci: null,

    meeting_location_options: {
      id: null,
      meeting_location: null,
      address: null,
    },

    key_location_options: {
      id: null,
      key_picker: null,
      key_location: null,
      address: null,
    },

    visitor_name: '',
    visitor_mail: '',
    visitor_phone: '',
    visitor_document: '',
    visitor_birth_date: '',

    term: null,
    attachment: null,

    worker_type: null,
    service_provider_user_id: null,

    base_report_id: null,
  },

  appointmentAddresses: [],
  appointmentFormStepsCurr: 1,
  appointmentFormStepsTotal: 6,
  appointmentHasMeetingLocation: true,
  appointmentAmount: null,
  appointmentHasUniqueRealtyServiceType: false,
  baseReportRequired: false,
}

const getters = {
  appointmentAmount: (state) => state.appointmentAmount,
  appointmentFields: (state) => state.appointmentFields,
  appointmentAddresses: (state) => state.appointmentAddresses,
  appointmentFormStepsCurr: (state) => state.appointmentFormStepsCurr,
  appointmentFormStepsTotal: (state) => state.appointmentFormStepsTotal,
  appointmentHasMeetingLocation: (state) => state.appointmentHasMeetingLocation,
  appointmentHasUniqueRealtyServiceType: (state) =>
    state.appointmentHasUniqueRealtyServiceType,
  baseReportRequired: (state) => state.baseReportRequired,
}

const mutations = {
  setAppointmentFields: ({ appointmentFields }, fields) => {
    state.appointmentFields = { ...appointmentFields, ...fields }
  },

  setAppointmentFormStepsTotal: (state, total) => {
    state.appointmentFormStepsTotal = total
  },

  setAppointmentFormStepsCurr: (state, current) => {
    state.appointmentFormStepsCurr = current
  },

  setAppointmentHasMeetingLocation: (state, status) => {
    state.appointmentHasMeetingLocation = status
  },

  setAppointmentAmount: (state, amount) => {
    state.appointmentAmount = amount
  },

  setAppointmentAddresses: (state, address) => {
    state.appointmentAddresses = address
  },

  setAppointmentHasUniqueRealtyServiceType: (
    state,
    hasUniqueRealtyServiceType
  ) => {
    state.appointmentHasUniqueRealtyServiceType = hasUniqueRealtyServiceType
  },

  setBaseReportRequired: (state, required) => {
    state.baseReportRequired = required
  },
}

const actions = {
  searchRealties({ commit, dispatch }, params) {
    return api.get('/web/realty/search', { params: params })
  },

  newAppointment({ commit, dispatch }, appointment, form) {
    return api.post('web/appointment/create', appointment)
  },

  resetAppointmentFields({ commit }) {
    const userRole = localStorage.getItem('access_roles') || ''
    const isServiceProviderUser = userRole.includes('ROLE_SERVICE_PROVIDER')

    commit('setHasTerm', false)
    commit('setHasAttachment', false)
    commit('setAppointmentHasMeetingLocation', true)
    commit('setIsTermUploadSuccessful', false)
    commit('setIsAttachmentUploadSuccessful', false)
    commit('setAppointmentFormStepsTotal', 6)
    commit('setAppointmentFormStepsCurr', 1)
    commit('setAppointmentAddresses', [])
    commit('setAppointmentAmount', null)
    commit('setBaseReportRequired', false)

    const appointmentFields = {
      type: null,
      external_code: null,
      inspector_id: null,
      date: null,

      realties: [],
      realties_complete: [],

      observations: null,
      displacement: 0,
      needs_authorization: false,
      fci: null,

      meeting_location_options: {
        id: null,
        meeting_location: null,
        address: null,
      },

      key_location_options: {
        id: null,
        key_picker: null,
        key_location: null,
        address: null,
      },

      visitor_name: '',
      visitor_mail: '',
      visitor_phone: '',
      visitor_document: '',
      visitor_birth_date: '',

      term: null,
      attachment: null,

      worker_type: null,
      service_provider_user_id: null,

      base_report_id: null,
    }

    if (!isServiceProviderUser) {
      appointmentFields.real_estate_branch_id = null
    }

    commit('setAppointmentFields', appointmentFields)
  },

  async getAppointmentAmount({ commit, dispatch }) {
    const amountData = {
      date: state.appointmentFields.date,
      type: state.appointmentFields.type,
      real_estate_id: state.appointmentFields.real_estate_id,
      realties_id: state.appointmentFields.realties,
      additionals_values: [state.appointmentFields.displacement ?? 0],
    }

    // prevent to calculate when form is cleared
    if (amountData.type && amountData.realties_id) {
      fetchAmount(amountData)
        .then(({ data }) => {
          commit('setAppointmentAmount', data.total_value)
        })
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? dispatch('showErrorMessage', data.errors[0].message)
            : dispatch('showErrorMessage', data.message)
        })
    }
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
}
